import React, {useEffect, useState} from 'react';
import {Link} from "types/Link";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    link: Link | null
    show: boolean
    onDelete?: (link: Link) => any
    onDeleteFail?: (link: Link, error: unknown) => any
    onCancel?: () => any
}

function DeleteLink(props: Props) {
    const {link, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(link?.text || 'this link');
    const {mutateAsync: deleteLink, isLoading} = useMutation(ngage.links.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(link) setName(link.text)
    }, [link]);

    async function handleDeleteLink() {
        if (link) {
            try {
                await deleteLink(link.id)
                await invalidate('links')

                notify("success", "Link Deleted", `${link.text} has been permanently removed`)
                if (onDelete) onDelete(link)
            } catch (error) {
                notify("error", "Link Not Deleted", `${link.text} could not be removed`)
                if (onDeleteFail) onDeleteFail(link, error)
            }
        }
    }

    function handleCancel() {
        if (!isLoading && onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Link"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteLink}
            onCancel={handleCancel}
        />
    );
}

export default DeleteLink;